<h2 mat-dialog-title>Logout</h2>
<mat-dialog-content class="mat-typography">
  <p>Theres data not synced yet and this will clear all data.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>CANCEL</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
